import { useState } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { Button } from "components/Button";
import { unsubscribePlan } from "features/Plans/service";
import { UnsubscribeStrategyModalContainer } from "./UnsubscribePlanModal.styles";
import { STRATEGY_UNSUB_REASONS_V2 } from "utils/constants";
import { Loader } from "components/Loader";
import { fetchUserDetails } from "Layout/slice/thunk";
import { useNavigation } from "utils/navigate";

const UnsubscribePlanModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const { navigateToDashboard } = useNavigation();
  const [reason, setReason] = useState("");
  const [isStopping, setStopping] = useState(false);

  const handleStop = async () => {
    setStopping(true);
    try {
      const response = await unsubscribePlan(reason);
      dispatch(
        toast({
          delay: 4000,
          body: response,
        })
      );
      onHide();
      dispatch(fetchUserDetails());
      navigateToDashboard();
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    } finally {
      setStopping(false);
    }
  };

  const handleReasonChange = (e) => {
    if (e.target.checked) {
      setReason(e.target.value);
    } else {
      setReason("");
    }
  };

  return (
    <UnsubscribeStrategyModalContainer heading="" show={show} onHide={onHide}>
      <div className="heading">
        <h2>Cancel Subscription</h2>
      </div>
      <div className="body-content">
        <span className="description">
          Please let us know the reason you are leaving
        </span>
        <div className="reasons">
          <Row>
            {STRATEGY_UNSUB_REASONS_V2.map((reasonData) => (
              <Col md={12} key={reasonData.value} className="radio-wrap">
                <input
                  id={reasonData.value}
                  name="unsubscribe_reason"
                  value={reasonData.value}
                  type="radio"
                  className="form-radio-input"
                  onChange={handleReasonChange}
                  checked={reasonData.value === reason}
                />
                <label htmlFor={reasonData.value}>{reasonData.label}</label>
              </Col>
            ))}
          </Row>
        </div>

        <div className="button-wrapper">
          <Row>
            <Col>
              <Button
                onClick={handleStop}
                label="Unsubscribe"
                className="btn-yes"
              >
                {isStopping ? (
                  <Loader className="on-btn" />
                ) : (
                  "Cancel subscription"
                )}
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </UnsubscribeStrategyModalContainer>
  );
};

UnsubscribePlanModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
};

export { UnsubscribePlanModal };
